const Configs = {
  baseURL: process.env.REACT_APP_API_URL_01,
  baseAPIURL01: process.env.REACT_APP_API_URL_01,
  baseAPIURL03: process.env.REACT_APP_API_URL_03,
  baseAPIURL06: process.env.REACT_APP_API_URL_06,
  baseAPIURL07: process.env.REACT_APP_API_URL_07,
  baseAPIURL08: process.env.REACT_APP_API_URL_08,
  baseAPIURL09: process.env.REACT_APP_API_URL_09,
  baseAPIURLATS: process.env.REACT_APP_API_URL_ATS,
  baseLINKLIFE: process.env.REACT_APP_LINK_LIFT_URL,
};

export default Configs;
